<template>
  <v-app-bar :clipped-right="true" :clipped-left="true" app fixed>
    <div>
      <img
        v-if="
          profileDetail &&
          profileDetail.company_details &&
          profileDetail.company_details.logo
        "
        contain
        aspect-ratio="1"
        height="30"
        class="pl-6"
        alt="Brand Logo"
        :src="profileDetail.company_details.logo"
      />
      <div v-else>
        <img
          contain
          aspect-ratio="1"
          height="30"
          class="pl-6"
          alt="Brand Logo"
          :src="$globalConstant.logo"
        />
      </div>
    </div>
    <v-spacer></v-spacer>
    <!-- <v-btn
      class="mr-3"
      text
      depressed
      color="primary"
      @click="$emit('showRightDrawer')"
      >Get Started</v-btn
    > -->

    <GoogleTranslate />

    <UserNotification v-model="openNotifications" />
    <v-btn
      v-if="
        ['account_admin', 'normal_user'].indexOf(this.profileDetail.role) > -1
      "
      text
      fab
      small
      class="text-primary"
      @click="$emit('showAnnouncements')"
    >
      <v-icon color="accent darken-3"> mdi-bullhorn </v-icon>
    </v-btn>
    <div class="d-flex algin-center ml-2">
      <div class="px-3">
        <h6
          class="text_color--text text-uppercase text-body-2 font-weight-bold pa-0 ma-0"
        >
          {{ profileDetail.first_name }} {{ profileDetail.last_name }}
        </h6>

        <h6
          class="text_color--text text-caption font-weight-light pa-0 ma-0 text-capitalize"
          v-if="
            profileDetail &&
            profileDetail.role &&
            ['account_manager', 'system_admin', 'support_user'].includes(
              profileDetail.role
            )
          "
        >
          {{ profileDetail.role.replace(/_/g, " ") }}
        </h6>
        <h6 v-else class="mt-1">
          <v-chip
            x-small
            v-if="
              profileDetail &&
              profileDetail.preferred_branch &&
              profileDetail.preferred_branch.name
            "
            class="error text-capitalize"
          >
            {{ profileDetail.preferred_branch.name }}
          </v-chip>
        </h6>
      </div>
    </div>
    <v-menu
      v-model="menu"
      :nudge-width="250"
      min-width="200px"
      offset-y
      transition="slide-y-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          depressed
          v-bind="attrs"
          v-on="on"
          style="min-width: 20px; padding: 0px"
        >
          <v-img
            class="mx-5 pr-4 profile-image"
            contain
            :src="
              profileDetail && profileDetail.profile_image
                ? profileDetail.profile_image
                : $globalConstant.profileImage
            "
            alt="User"
          />
        </v-btn>
      </template>
      <v-card elevation="0" width="auto" min-width="300">
        <v-row no-gutters>
          <v-col cols="4" class="text-center py-3 px-0">
            <v-img
              class="mx-5 pr-4 profile-image"
              style="height: 50px !important; width: 50px !important"
              contain
              :src="
                profileDetail && profileDetail.profile_image
                  ? profileDetail.profile_image
                  : $globalConstant.profileImage
              "
              alt="User"
            />
          </v-col>
          <v-col cols="8" class="d-flex flex-column justify-center">
            <h5
              class="text_color--text text-capitalize d-flex justify-space-between"
            >
              <span>
                {{ profileDetail.first_name }}
                {{ profileDetail.last_name }}
              </span>
              <span class="pr-6">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      color="secondary"
                      small
                      @click="openProfileDialog = true"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <span class="text-capitalize text-no-wrap">Edit Profile</span>
                </v-tooltip>
              </span>
            </h5>
            <h5
              class="text-body-2 font-weight-light text-capitalize"
              v-if="profileDetail.role"
            >
              {{ profileDetail.role.replace(/_/g, " ") }}
            </h5>
          </v-col>
        </v-row>

        <v-card-text class="px-8 pt-0">
          <div class="d-flex my-2" v-if="profileDetail.username">
            <div>
              <v-icon small class="mr-4 primary--text">mdi-account</v-icon>
            </div>
            <div>
              <span class="text-caption">
                <BaseTooltip :text="profileDetail.username" title="username" />
              </span>
            </div>
          </div>
          <div class="d-flex my-2" v-if="profileDetail.company_name">
            <div>
              <v-icon small class="mr-4 primary--text">mdi-domain</v-icon>
            </div>
            <div>
              <span class="text-caption">
                <BaseTooltip
                  :text="profileDetail.company_name"
                  title="Company Name"
                />
              </span>
            </div>
          </div>
          <div class="d-flex my-2" v-if="profileDetail.contact_number">
            <div>
              <v-icon small class="mr-4 primary--text">mdi-phone</v-icon>
            </div>
            <div>
              <span class="text-caption">
                <BaseTooltip
                  :text="profileDetail.contact_number"
                  title="contact number"
                />
              </span>
            </div>
          </div>

          <div class="d-flex my-2" v-if="profileDetail.email">
            <div>
              <v-icon small class="mr-4 primary--text">mdi-email</v-icon>
            </div>
            <div>
              <span class="text-caption">
                <BaseTooltip
                  :text="profileDetail.email"
                  title="contact Email"
                />
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4"></v-divider>

        <v-card-text class="pa-0">
          <v-list>
            <v-list-item
              :to="{ name: 'company-configuration' }"
              v-if="
                profileDetail &&
                profileDetail.role &&
                ['account_admin', 'normal_user'].indexOf(profileDetail.role) >
                  -1
              "
            >
              <v-icon class="pr-3">mdi-cog</v-icon>
              <span class="pl-2">Settings</span>
            </v-list-item>
            <v-list-item
              @click="showBranchChangeDialog = true"
              v-if="
                profileDetail &&
                profileDetail.role &&
                ['account_admin', 'normal_user'].indexOf(profileDetail.role) >
                  -1
              "
            >
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-icon class="pr-3">mdi-warehouse</v-icon>
                    <span class="pl-2">{{
                      selectedBranch ? selectedBranch.name : "Not Selected"
                    }}</span>
                  </div>
                </template>
                <span>Change Branch</span>
              </v-tooltip>
            </v-list-item>
            <v-list-item @click="showChangePasswordForm = true">
              <v-icon class="pr-3">mdi-key</v-icon>
              <span class="pl-2 text-capitalize">Change Password</span>
            </v-list-item>
            <v-list-item
              @click="showChangeConfigurationForm = true"
              v-if="
                profileDetail &&
                profileDetail.role &&
                ['account_admin'].includes(profileDetail.role)
              "
            >
              <v-icon class="pr-3">mdi-wrench</v-icon>
              <span class="pl-2 text-capitalize">Change Configuration</span>
            </v-list-item>
            <v-list-item @click="logout">
              <v-icon class="pr-3">mdi-logout</v-icon>
              <span class="pl-2 text-capitalize">logout</span>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-menu>

    <Profile v-model="openProfileDialog" @logout="logout" />
    <BranchSelection v-model="showBranchChangeDialog" />
    <ChangePassword v-model="showChangePasswordForm" @logout="logout" />
    <ChangeConfiguration v-model="showChangeConfigurationForm" />
  </v-app-bar>
</template>

<script>
import Profile from "@/components/BaseComponents/Profile.vue";
import BranchSelection from "./BranchSelection.vue";
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";
import UserNotification from "./UserNotification.vue";
import GoogleTranslate from "./GoogleTranslate.vue";
import { changeTheme, defaultTheme } from "@/utils/functions";
import ChangePassword from "@/components/ModuleBasedComponents/NormalUser/ChangePassword.vue";
import ChangeConfiguration from "@/components/ModuleBasedComponents/NormalUser/ChangeConfiguration.vue";
import { eraseCookie } from "@/utils/cookieHandlers";
export default {
  emits: ["showRightDrawer", "showAnnouncements"],
  components: {
    Profile,
    BranchSelection,
    BaseTooltip,
    UserNotification,
    GoogleTranslate,
    ChangePassword,
    ChangeConfiguration,
  },
  data() {
    return {
      changeTheme,
      title: "Customer Profiling",
      profileDetail: {},
      menu: false,
      openProfileDialog: false,
      showBranchChangeDialog: false,
      branchWithAccess: [],
      openNotifications: false,
      showAnnouncementDrawer: false,

      showChangePasswordForm: false,
      showChangeConfigurationForm: false,

      userDetails: this.$helper.getUserDetailsLocalStorage(),
    };
  },
  computed: {
    selectedBranch() {
      if (this.branchWithAccess.length > 0 && this.profileDetail) {
        return this.branchWithAccess.find(
          (obj) => obj.id == this.profileDetail.preferred_branch.id
        );
      } else {
        return null;
      }
    },
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$wbSocket.closeConnection();
      this.$wbSocket.notificationCloseConnection();
      this.changeTheme(defaultTheme, this.$vuetify);
      this.$router.push({ name: "login" });

      if (!["system_admin"].includes(this.userDetails.role)) {
        eraseCookie("currentLanguage");
        eraseCookie("googtrans");
        if (window) {
          location.reload();
        }
      }
    },
    getBranchList() {
      this.branchWithAccess = [];
      this.$api.branch
        .getBranchSelectList({ limit: "all" })
        .then((res) => {
          this.branchWithAccess = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  created() {
    let interval = setInterval(() => {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        clearInterval(interval);
        this.profileDetail = obj;
        if (
          ["account_admin", "normal_user"].indexOf(this.profileDetail.role) > -1
        ) {
          this.getBranchList();
        }
      }
    }, 100);
  },
};
</script>

<style scoped lang="scss">
.profile-image {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
}
</style>
